import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { createDeliveryNoteAsync, getAllDeliveryNoteAsync, updateDeliveryNoteAsync } from './deliverynoteThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const deliveryNoteSlice = createSlice({
    name: 'deliveryNote',
    initialState,
    reducers: {
        setDeliveryNoteNumber: (state, action) => {
            state.deliveryNoteNumber = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllDeliveryNoteAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllDeliveryNoteAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.deliveryNotes = action.payload;
        })
            .addCase(getAllDeliveryNoteAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createDeliveryNoteAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createDeliveryNoteAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(createDeliveryNoteAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateDeliveryNoteAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateDeliveryNoteAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(updateDeliveryNoteAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default deliveryNoteSlice.reducer;
export const { setDeliveryNoteNumber } = deliveryNoteSlice.actions;
